module.exports = __webpack_public_path__ + "static/media/5.4e4f676c.jpg";